// Re-export all action constants from actions/index.js
export * from './actions/index';

// athlete profile modal
export const CREATE_ATHLETE = 'athletes/CREATE_ATHLETE';
export const EDIT_ATHLETE = 'athletes/EDIT_ATHLETE';
export const CLOSE_CREATE_ATHLETE = 'athletes/CLOSE_CREATE_ATHLETE';
export const CLOSE_EDIT_ATHLETE = 'athletes/CLOSE_EDIT_ATHLETE';
export const UPDATE_ATHLETE_FIRST_NAME = 'athletes/UPDATE_ATHLETE_FIRST_NAME';
export const UPDATE_ATHLETE_MIDDLE_NAME = 'athletes/UPDATE_ATHLETE_MIDDLE_NAME';
export const UPDATE_ATHLETE_LAST_NAME = 'athletes/UPDATE_ATHLETE_LAST_NAME';
export const UPDATE_ATHLETE_TEAM = 'athletes/UPDATE_ATHLETE_TEAM';
export const UPDATE_ATHLETE_GROUP = 'athletes/UPDATE_ATHLETE_GROUP';
export const UPDATE_ATHLETE_EMAIL = 'athletes/UPDATE_ATHLETE_EMAIL';
export const ATTEMPT_CANCEL_ATHLETE_INVITE = 'ATTEMPT_CANCEL_ATHLETE_INVITE';
export const CANCEL_ATHLETE_INVITE_SUCCEEDED = 'CANCEL_ATHLETE_INVITE_SUCCEEDED'; 